// extracted by mini-css-extract-plugin
var _1 = "SequenceSlideout__backdrop--xL3kI";
var _2 = "SequenceSlideout__chapterTitleText--gAQFg CoreGeneral__robotoSlab--X8lgW";
var _3 = "SequenceSlideout__closed--CsCjZ SequenceSlideout__main--eyyct";
var _4 = "SequenceSlideout__content--rwEOD";
var _5 = "SequenceSlideout__contentContainer--apdtU";
var _6 = "SequenceSlideout__emptyCurrent--stxzz";
var _7 = "SequenceSlideout__forTeacher--ZfhA3";
var _8 = "SequenceSlideout__grade-1Color--A7TvN Colors__grade-1Color--Kz8le";
var _9 = "SequenceSlideout__grade-2Color--velo6 Colors__grade-2Color--_2wYG";
var _a = "SequenceSlideout__grade-3Color--qFSjg Colors__grade-3Color--fN2JV";
var _b = "SequenceSlideout__grade-4Color--Se2Fy Colors__grade-4Color--QbjlL";
var _c = "SequenceSlideout__grade-5Color--CsI3k Colors__grade-5Color--hRuJo";
var _d = "SequenceSlideout__hideBackdrop--oaKKz SequenceSlideout__backdrop--xL3kI";
var _e = "SequenceSlideout__homeworkIcon--vtWql";
var _f = "SequenceSlideout__homeworkLink--LFJbY SchoolGeneral__link--tS8wu OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _10 = "SequenceSlideout__homeworkLinkContainer--rkMCc";
var _11 = "SequenceSlideout__icon--G2kt4";
var _12 = "SequenceSlideout__largerText--JF_5w";
var _13 = "SequenceSlideout__main--eyyct";
var _14 = "SequenceSlideout__open--UiXgt SequenceSlideout__main--eyyct";
var _15 = "SequenceSlideout__scrollArea--Wjc2Q";
var _16 = "SequenceSlideout__showBackdrop--bbRhQ SequenceSlideout__backdrop--xL3kI";
var _17 = "SequenceSlideout__title--rHMii";
var _18 = "SequenceSlideout__titleText--J4m6Z";
var _19 = "SequenceSlideout__toggle--Yauxy";
var _1a = "SequenceSlideout__toggleIcon--MSVx7";
var _1b = "SequenceSlideout__topContainer--XVS3N";
var _1c = "SequenceSlideout__trayContainer--z7sC2";
var _1d = "SequenceSlideout__trayImg--mkE3Q";
var _1e = "SequenceSlideout__yBar--anwau";
var _1f = "SequenceSlideout__yThumb--7YEqL";
export { _1 as "backdrop", _2 as "chapterTitleText", _3 as "closed", _4 as "content", _5 as "contentContainer", _6 as "emptyCurrent", _7 as "forTeacher", _8 as "grade-1Color", _9 as "grade-2Color", _a as "grade-3Color", _b as "grade-4Color", _c as "grade-5Color", _d as "hideBackdrop", _e as "homeworkIcon", _f as "homeworkLink", _10 as "homeworkLinkContainer", _11 as "icon", _12 as "largerText", _13 as "main", _14 as "open", _15 as "scrollArea", _16 as "showBackdrop", _17 as "title", _18 as "titleText", _19 as "toggle", _1a as "toggleIcon", _1b as "topContainer", _1c as "trayContainer", _1d as "trayImg", _1e as "yBar", _1f as "yThumb" }
